module.exports = __webpack_public_path__ + "img/increase_credit_limit.125a718a.png";